import type { Template } from "@/types";

export const LA_06_H5_V1: Template[] = [
    {
        id: "la-06-h5v1-01",
        name: "LA 01 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h5_v1_01.png",
        size: [1352, 483],
        style: {},
        slots: [       
            { id: "1", x: 77, y: 41, width: 208, height: 128, rotation: 0, imageRotation: 0 },
            { id: "2", x: 77, y: 177, width: 208, height: 128, rotation: 0, imageRotation: 0 },
            { id: "3", x: 293, y: 41, width: 305, height: 400, rotation: 0, imageRotation: 0 },
            { id: "4", x: 77, y: 313, width: 208, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 856, y: 42, width: 315, height: 196, rotation: 0, imageRotation: 0 },
            { id: "6", x: 856, y: 246, width: 315, height: 196, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-02",
        name: "LA 02 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h5_v1_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 110, y: 41, width: 295, height: 400, rotation: 0, imageRotation: 0 },     
            { id: "2", x: 412, y: 41, width: 144, height: 94, rotation: 0, imageRotation: 0 },
            { id: "3", x: 412, y: 143, width: 144, height: 94, rotation: 0, imageRotation: 0 },
            { id: "4", x: 412, y: 245, width: 144, height: 94, rotation: 0, imageRotation: 0 },
            { id: "5", x: 412, y: 347, width: 144, height: 94, rotation: 0, imageRotation: 0 },
            { id: "6", x: 781, y: 96, width: 468, height: 291, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-03",
        name: "LA 03 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h5_v1_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 107, y: 74, width: 231, height: 336, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 346, y: 74, width: 229, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 346, y: 246, width: 229, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 804, y: 50, width: 420, height: 249, rotation: 0, imageRotation: 0 },
            { id: "5", x: 804, y: 306, width: 206, height: 129, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 306, width: 206, height: 129, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-04",
        name: "LA 04 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h5_v1_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 157, y: 34, width: 336, height: 195, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 157, y: 236, width: 164, height: 103, rotation: 0, imageRotation: 0 },
            { id: "3", x: 157, y: 347, width: 164, height: 103, rotation: 0, imageRotation: 0 },
            { id: "4", x: 329, y: 236, width: 164, height: 103, rotation: 0, imageRotation: 0 },
            { id: "5", x: 329, y: 347, width: 164, height: 103, rotation: 0, imageRotation: 0 },
            { id: "6", x: 867, y: 33, width: 293, height: 416, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-05",
        name: "LA 05 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h5_v1_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 71, y: 72, width: 535, height: 339, rotation: 0, imageRotation: 0 },
            { id: "2", x: 806, y: 46, width: 204, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 806, y: 179, width: 204, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 806, y: 312, width: 204, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 312, width: 204, height: 125, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 46, width: 204, height: 258, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-06",
        name: "LA 06 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h5_v1_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 62, y: 85, width: 238, height: 153, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 245, width: 238, height: 152, rotation: 0, imageRotation: 0 },
            { id: "3", x: 307, y: 85, width: 238, height: 153, rotation: 0, imageRotation: 0 },
            { id: "4", x: 307, y: 245, width: 238, height: 152, rotation: 0, imageRotation: 0 },
            { id: "5", x: 774, y: 85, width: 516, height: 312, rotation: 0, imageRotation: 0 },
            { id: "6", x: 552, y: 85, width: 214, height: 312, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-07",
        name: "LA 07 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h5_v1_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 62, y: 85, width: 238, height: 153, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 245, width: 238, height: 152, rotation: 0, imageRotation: 0 },
            { id: "3", x: 307, y: 85, width: 214, height: 312, rotation: 0, imageRotation: 0 },
            { id: "4", x: 529, y: 85, width: 238, height: 153, rotation: 0, imageRotation: 0 },
            { id: "5", x: 529, y: 245, width: 238, height: 152, rotation: 0, imageRotation: 0 },
            { id: "6", x: 774, y: 85, width: 516, height: 312, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-08",
        name: "LA 08 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h5_v1_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 62, y: 85, width: 238, height: 153, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 245, width: 238, height: 152, rotation: 0, imageRotation: 0 },
            { id: "3", x: 307, y: 85, width: 214, height: 312, rotation: 0, imageRotation: 0 },
            { id: "4", x: 529, y: 85, width: 516, height: 312, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1052, y: 85, width: 238, height: 153, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1052, y: 245, width: 238, height: 152, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-09",
        name: "LA 09 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h5_v1_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 49, y: 38, width: 297, height: 408, rotation: 0, imageRotation: 0 },
            { id: "2", x: 354, y: 38, width: 274, height: 157, rotation: 0, imageRotation: 0 },
            { id: "3", x: 354, y: 291, width: 274, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 354, y: 202, width: 134, height: 82, rotation: 0, imageRotation: 0 },
            { id: "5", x: 495, y: 202, width: 133, height: 82, rotation: 0, imageRotation: 0 },
            { id: "6", x: 635, y: 38, width: 668, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-10",
        name: "LA 10 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h5_v1_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 107, y: 142, width: 158, height: 96, rotation: 0, imageRotation: 0 },
            { id: "2", x: 107, y: 246, width: 158, height: 96, rotation: 0, imageRotation: 0 },
            { id: "3", x: 107, y: 350, width: 158, height: 96, rotation: 0, imageRotation: 0 },
            { id: "4", x: 273, y: 38, width: 296, height: 408, rotation: 0, imageRotation: 0 },
            { id: "5", x: 577, y: 38, width: 668, height: 408, rotation: 0, imageRotation: 0 },
            { id: "6", x: 107, y: 38, width: 158, height: 96, rotation: 0, imageRotation: 0 }         
        ],
    }
];